import { randomInt } from "../Enemy/enemy.js";
import Shield from "./shield.js";
import Turret from "./turret.js";

export default function PickupGenerator() {
  const num = randomInt(0, 1);
  switch (num) {
    case 0:
      return new Shield();
    case 1:
      return new Turret();
    default:
      break;
  }
}
